import { render, staticRenderFns } from "./Iletisim.vue?vue&type=template&id=349f655b&scoped=true&"
import script from "./Iletisim.vue?vue&type=script&lang=js&"
export * from "./Iletisim.vue?vue&type=script&lang=js&"
import style0 from "./Iletisim.vue?vue&type=style&index=0&id=349f655b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349f655b",
  null
  
)

export default component.exports